import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import Header from "../../containers/Header";
import MainLayout from "../../layouts/MainLayout";
import Footer from "../../containers/Footer";

import { Container, Row, Col, Card, Modal, Button } from "react-bootstrap";
// For animations
import { Fade } from "react-awesome-reveal";

import MasterForm from "../../components/MultiStepForm/Invoices/MasterForm";

const insurrances = [
  {
    id: 1,
    name: "auto",
    fullname: "Assurance Automobile",
    image:
      "https://res.cloudinary.com/dnfpmrdjl/image/upload/v1659843101/car_m2l5jx.jpg",
  },
  {
    id: 2,
    name: "travel",
    fullname: "Assurance voyage",
    image:
      "https://res.cloudinary.com/dnfpmrdjl/image/upload/v1659842676/travel_q7uglb.jpg",
  },
  {
    id: 3,
    name: "accident",
    fullname: "TAME",
    image:
      "https://res.cloudinary.com/dnfpmrdjl/image/upload/v1659845372/tame_ibsj1x.jpg",
  },
  {
    id: 4,
    name: "rcf",
    fullname: "Assurance responsabilité chef de famille",
    image:
      "https://res.cloudinary.com/dnfpmrdjl/image/upload/v1659843822/fam_ae1zwq.jpg",
  },
  {
    id: 5,
    name: "rcs",
    fullname: "Assurance responsabilité civile scolaire",
    image:
      "https://res.cloudinary.com/dnfpmrdjl/image/upload/v1659841330/rc-scolaire_vmqib4.jpg",
  },
  {
    id: 6,
    name: "rcp",
    fullname: "Assurance responsabilité civil des professions libérales",
    image:
      "https://res.cloudinary.com/dnfpmrdjl/image/upload/v1659844039/lwayer_pq9pwo.jpg",
  },
  {
    id: 7,
    name: "rch",
    fullname: "Assurance Habitation",
    image:
      "https://res.cloudinary.com/dnfpmrdjl/image/upload/v1655366335/Home_insurance_eepvit.svg",
  },
];

const Invoices = () => {
  const [showFormModal, setShowFormModal] = useState(false);
  const [activeObject, setActiveObject] = useState(null);

  const showModal = () => setShowFormModal(true);
  const hideModal = () => setShowFormModal(false);

  const { t } = useTranslation();
  const history = useNavigate();

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <Header
        caption={t("invoice_page_header_title")}
        bgImg={
          "https://res.cloudinary.com/dnfpmrdjl/image/upload/v1655461136/insurrances-img-header_mc60pr.svg"
        }
      />
      <MainLayout pageCSS="invoice-page">
        <h2 className="">{t("invoice_page_caption_text")}</h2>

        <Modal show={showFormModal} onHide={hideModal} centered>
          {activeObject ? (
            <MasterForm
              id={activeObject.id}
              fullname={activeObject.fullname}
              invoiceName={activeObject.name}
            />
          ) : null}

          <Modal.Footer>
            <Button variant="red" onClick={hideModal}>
              Close
            </Button>
            {/* <Button variant="blue" onClick={hideModal}>
            Save Changes
          </Button> */}
          </Modal.Footer>
        </Modal>
        <Container>
          <Row>
            <Fade
              triggerOnce
              cascade
              direction="right"
              className="col col-md-4"
            >
              {insurrances?.map((insurrance) => (
                <Col key={insurrance.id} className="d-flex">
                  <Card
                    style={{ width: "46rem" }}
                    onClick={() => {
                      setActiveObject(insurrance);
                      showModal();
                    }}
                  >
                    <Card.Img
                      variant="top"
                      src={insurrance.image}
                      style={{ height: "28rem" }}
                    ></Card.Img>
                    <Card.Title
                      style={{
                        fontSize: "2rem",
                        display: "flex",
                        justifyContent: "center",
                        height: "5rem",
                        alignItems: "center",
                      }}
                    >
                      {insurrance.fullname}
                    </Card.Title>
                  </Card>
                </Col>
              ))}
            </Fade>
          </Row>
        </Container>
      </MainLayout>
      <Footer />
    </motion.div>
  );
};

export default Invoices;
